export const getMealNames = (meal) => {
  if (!Array.isArray(meal?.details)) {
    return [];
  }

  return meal.details
    .map((detail) => detail?.name?.trim())
    .filter(Boolean);
};

export const getLocalizedMealName = (meal, language = 'English') => {
  const mealNames = getMealNames(meal);

  if (mealNames.length === 0) {
    return '';
  }

  return language === 'English'
    ? meal?.details?.[0]?.name ?? mealNames[0]
    : meal?.details?.[1]?.name ?? meal?.details?.[0]?.name ?? mealNames[0];
};

export const getSearchableMealText = (meal) => getMealNames(meal).join(' ');

export const mealMatchesSearch = (meal, searchValue = '') => {
  const normalizedSearchValue = searchValue.trim().toLowerCase();

  if (!normalizedSearchValue) {
    return true;
  }

  return getMealNames(meal).some((name) =>
    name.toLowerCase().includes(normalizedSearchValue)
  );
};
